import React, {useEffect, useState} from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Brush,
  LineChart,
  Line, ResponsiveContainer
} from "recharts";
import {toJS} from "mobx";
import graphsService from "./graph-service";
import {debounce} from "lodash"
import {numberFormatted} from "../utils/graph.util";
import store from "../../store";
import {Radio} from "../radio-btn";
// import BeatLoader from "react-spinners/BeatLoader";

export default function LineDayChart(props) {
  const [group_by, setGroupBy] = useState('day');
  const [data_key, setDataKey] = useState('');
  const [app_type, setAppType] = useState('all');
  const [graph_type, setGraphType] = useState(props.graph_type);
  const [set_to_default, setToDefault] = useState(false);
  const [entities_data, setEntitiesData] = useState([]);
  const [days_brush_indexes, setDaysBrushIndexes] = useState([0, 6]);

  useEffect(() => {
    setToDefault(true);
    setDataKey(props.data_key);
    setEntitiesData(props.entities);

    setGraphType(props.graph_type);
    setAppType(props.app_type);
    setGroupBy(props.group_by);

  }, [props.entities]);

  const brushChange = async ({startIndex, endIndex}) => {
    setDaysBrushIndexes([startIndex, endIndex]);
  };

  // const allSegments = () => {
  //   setGraphType('full_segments');
  //   const kpi = props.data_key;
  //   const days = toJS(props.entities);
  //   const start_day = days[days_brush_indexes[0]]?.day ?? props.entities[0]?.day;
  //   const end_day = days[days_brush_indexes[1]]?.day ?? props.entities[props.entities.length - 1]?.day;
  //
  //   debounce(async function () {
  //     // const all_segments = await graphsService.fetchFullSegmentsData(kpi, app_type,
  //     //   store.modified_start_date ? store.modified_start_date : start_day,
  //     //   store.modified_end_date ? store.modified_end_date : end_day,
  //     //   'day'
  //     // );
  //     const full_segments = await graphsService.fetchEntityGraphData(kpi, app_type,
  //       store.modified_start_date ? store.modified_start_date : start_day,
  //       store.modified_end_date ? store.modified_end_date : end_day,
  //       group_by, 'full_segments');
  //     setEntitiesData(full_segments);
  //   }, 1000)();
  //
  //   // setAllSegments(true);
  // }

  // const toHoursClick = () => {
  //   const kpi = props.data_key;
  //   const days = toJS(props.entities);
  //   const start_day = days[days_brush_indexes[0]]?.day ?? props.entities[0]?.day;
  //   const end_day = days[days_brush_indexes[1]]?.day ?? props.entities[props.entities.length - 1]?.day;
  //
  //   // setToDefault(false);
  //   // setGraphType(default_graph_type_to_return_to);
  //
  //   debounce(async function () {
  //     const kpiDays = await graphsService.fetchEntityGraphData(kpi, app_type,
  //       store.modified_start_date ? store.modified_start_date : start_day,
  //       store.modified_end_date ? store.modified_end_date : end_day,
  //       'hour', graph_type);
  //     setDataKey('value');
  //     setGroupBy('hour');
  //     setEntitiesData(kpiDays);
  //   }, 1000)();

    // const sub_days = days_brush_indexes[1] - days_brush_indexes[0];
    //
    // if (sub_days <= max_days_to_show_hours) {
    //   const kpi = props.data_key;
    //   const days = toJS(props.entities);
    //   const start_day = days[days_brush_indexes[0]].day;
    //   const end_day = days[days_brush_indexes[1]].day;
    //
    //   debounce(async function () {
    //     const kpiHours = await graphsService.fetchEntityGraphData(kpi, app_type, start_day, end_day, 'hour');
    //     setGroupBy('hour');
    //     setDataKey('value');
    //     setEntitiesData(kpiHours);
    //   }, 1000)();
    // }
  // };
  //
  // const toDaysClick = () => {
  //   const kpi = props.data_key;
  //   const days = toJS(props.entities);
  //   const start_day = days[days_brush_indexes[0]]?.day ?? props.entities[0]?.day;
  //   const end_day = days[days_brush_indexes[1]]?.day ?? props.entities[props.entities.length - 1]?.day;
  //
  //   setToDefault(false);
  //   setGraphType(default_graph_type_to_return_to);
  //
  //   debounce(async function () {
  //     const kpiDays = await graphsService.fetchEntityGraphData(kpi, app_type,
  //       store.modified_start_date ? store.modified_start_date : start_day,
  //       store.modified_end_date ? store.modified_end_date : end_day,
  //       'day', default_graph_type_to_return_to);
  //     setDataKey('value');
  //     setGroupBy('day');
  //     setEntitiesData(kpiDays);
  //   }, 1000)();
  // };

  const handleGraphDataTypeChange = async (data) => {
    let graph_type_temp = graph_type;
    let app_type_temp = app_type;
    let group_by_temp = group_by;

    if (data.input === "group_by") {
      setGroupBy(data.value);
      group_by_temp = data.value;
    } else if (data.input === "graph_type") {
      setGraphType(data.value);
      graph_type_temp = data.value;
    } else if (data.input === "app_type") {
      setAppType(data.value);
      app_type_temp = data.value;
    }
    const kpi = props.data_key;
    const days = toJS(props.entities);
    const start_day = days[days_brush_indexes[0]].day || props.entities[0].day;
    const end_day = days[days_brush_indexes[1]].day || props.entities[props.entities.length - 1].day;

    debounce(async function () {
      const response = await graphsService.fetchEntityGraphData(
        kpi,
        app_type_temp,
        store.modified_start_date ? store.modified_start_date : start_day,
        store.modified_end_date ? store.modified_end_date : end_day,
        group_by_temp, graph_type_temp
      );

      setDataKey('value');
      setEntitiesData(response);
    }, 1000)();
  };

  return (
    <>
      {
        props.data_key !== 'day' &&
        <div className='shadow-lg p-1 p-4 bg-white dark:bg-gray-800'>
          <span className="text-gray-700 dark:text-gray-100 text-left font-bold my-4">
            {props.label.toLocaleUpperCase()} - {group_by} - {app_type}
            {/*<BeatLoader loading={true} cssOverride={loader_override} size={8} />*/}
          </span>
          <Radio checked={group_by}
                 input='group_by'
                 cb={handleGraphDataTypeChange}
                 buttons={[
                   {placeholder: 'Daily', value: 'day'},
                   {placeholder: 'Hourly', value: 'hour'},
                 ]}/>
          <Radio checked={graph_type}
                 input='graph_type'
                 cb={handleGraphDataTypeChange}
                 buttons={[
                   {placeholder: 'Total', value: 'none'},
                   {placeholder: 'Twik & Control', value: 'twik_control_segments'},
                   {placeholder: 'All segments', value: 'all_segments'},
                 ]}/>
          <Radio checked={app_type}
                 input='app_type'
                 cb={handleGraphDataTypeChange}
                 buttons={[
                   {placeholder: 'All', value: 'all'},
                   {placeholder: 'Shopify', value: 'shopify'},
                   {placeholder: 'Wix', value: 'wix'},
                   {placeholder: 'Enterprise', value: 'enterprise'},
                 ]}/>
          <ResponsiveContainer width="100%"
                               height={500}>
          <LineChart
            width={550}
            height={400}
            data={entities_data}
            // syncId="anyId"
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 0
            }}
          >
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey={group_by}/>
            <YAxis tickFormatter={numberFormatted()}/>
            <Tooltip coordinate={{ x: 1000, y: 1000 }} formatter={numberFormatted()}/>
            <Line type="monotone" dataKey={data_key} stroke="#8884d8"
              // fill={fill_colors[props.index]}
                  fill='#fedc97'
                  dot={(<></>)}
            />
            <Brush
              height={20} stroke="#8884d8"
              startIndex={0}
              endIndex={props.entities.length - 1}
              onChange={brushChange}
              dataKey={group_by}/>
            {
              graph_type == 'all_segments' && (
                <>
                  <Line type="monotone" dot={(<></>)} dataKey='control' stroke="#A25B5B" fill='#A25B5B'/>
                  <Line type="monotone" dot={(<></>)} dataKey='twik' stroke="#377D71" fill='#377D71'/>
                  <Line type="monotone" dot={(<></>)} dataKey='non_elig' stroke="#51557E" fill='#51557E'/>
                  <Line type="monotone" dot={(<></>)} dataKey='non_targeted' stroke="#A0D995" fill='#A0D995'/>
                  <Line type="monotone" dot={(<></>)} dataKey='prev_undefined' stroke="#ECB390" fill='#ECB390'/>
                  <Line type="monotone" dot={(<></>)} dataKey='replace' stroke="#F637EC" fill='#F637EC'/>
                  <Line type="monotone" dot={(<></>)} dataKey='unknown' stroke="#FFA500" fill='#FFA500'/>
                  <Line type="monotone" dot={(<></>)} dataKey='null_users' stroke="#94B49F" fill='#94B49F'/>
                  {/*      /!*<Line type="monotone" dot={(<></>)} dataKey='excluded_control'        stroke="#FBC5C5" fill='#FBC5C5'/>*!/*/}
                  {/*      /!*<Line type="monotone" dot={(<></>)} dataKey='excluded_non_elig'       stroke="#8879B0" fill='#8879B0'/>*!/*/}
                  {/*      /!*<Line type="monotone" dot={(<></>)} dataKey='excluded_non_targeted'   stroke="#2C3639" fill='#2C3639'/>*!/*/}
                  {/*      /!*<Line type="monotone" dot={(<></>)} dataKey='excluded_prev_undefined' stroke="#A27B5C" fill='#A27B5C'/>*!/*/}
                  {/*      /!*<Line type="monotone" dot={(<></>)} dataKey='excluded_replace'        stroke="#54BAB9" fill='#54BAB9'/>*!/*/}
                  {/*      /!*<Line type="monotone" dot={(<></>)} dataKey='excluded_twik'           stroke="#E9DAC1" fill='#E9DAC1'/>*!/*/}
                </>
              )
            }
            {
              graph_type == 'twik_control_segments' && (
                <>
                  <Line type="monotone" dot={(<></>)} dataKey='twik' stroke="#377D71" fill='#377D71' />
                  <Line type="monotone" dot={(<></>)} dataKey='control' stroke="#A25B5B" fill='#A25B5B'/>
                </>
              )
            }
          </LineChart>
        </ResponsiveContainer>
        </div>
      }
    </>
  );
}
